import { CHUNK_IMPORT_FAILURE_PATTERNS as n } from "../../constants/chunkError.constants.js";
var a = (t) => {
  if (typeof t == "string") return t;
  if (t instanceof Error) return t.message;
  if (typeof t != "object" || t === null) return "";
  const e = t.message;
  return typeof e == "string" ? e : "";
}, i = (t) => {
  const e = a(t);
  return e ? n.some((s) => s.test(e)) : !1;
};
export {
  i as isChunkImportFailure
};

//# sourceMappingURL=chunkError.helper.js.map